export default "__VITE_ASSET__DKkU5i9y__"